import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const NavigationMenuWrapper = styled.div`
  padding: ${Spacing.S12} 0;
  overflow: auto;
`
